/**
 * Product Recommend API (V2)
 * Server: GET/POST/DELETE /api/v1/products/{product_id}/recommends
 */

import { ApiBase } from "../../../core/api-base";
import { z } from "zod";
import { UpsertProductRecommendBody } from "../../../api/generated/products.zod";

type UpsertProductRecommendPayload = z.infer<typeof UpsertProductRecommendBody>;

export class ProductRecommendApi extends ApiBase {
    public static async getMeta(productId: number): Promise<Response> {
        return await super.apiGet(`/api/v1/products/${productId}/recommends`, { noSpinner: true });
    }

    public static async upsert(productId: number, rank: number | null): Promise<Response> {
        const payload: UpsertProductRecommendPayload = { rank: rank === null ? null : Number(rank) };
        return await super.apiPost(`/api/v1/products/${productId}/recommends`, payload, { noSpinner: true });
    }

    public static async remove(productId: number): Promise<Response> {
        return await super.apiDelete(`/api/v1/products/${productId}/recommends`, { noSpinner: true });
    }

    public static async clearAll(): Promise<Response> {
        return await super.apiDelete("/api/v1/products/recommends/clear", { noSpinner: true });
    }
}
